// access.js
import { DEFAULT_ROLE_PERMISSIONS } from "./defaultRolePermissions";

/**
 * Checks if a user has a certain permission.
 * For now, only looks at the user's role.
 * 
 * @param {object} user - The user object from context, must have `rooli`.
 * @param {string} permission - The permission string to check.
 * @returns {boolean} true if allowed, false otherwise
 */
export function can(user, permission) {
  if (!user || !user.rooli) return false;

  const allowedPermissions = DEFAULT_ROLE_PERMISSIONS[user.rooli] || [];
  return allowedPermissions.includes(permission);
}
